<mat-toolbar class="mat-elevation-z8">
  {{ 'PARKING_PRICING.TITLE' | transloco }}
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<mat-dialog-content class="mt-3">
  <form [formGroup]="parkingPricingForm">
    <mat-form-field class="mb-2 w-100">
      <input matInput [placeholder]="'PARKING_PRICING.NAME' | transloco" formControlName="name" required>
      @if (!parkingPricingForm.controls.name.valid && parkingPricingForm.controls.name.touched) {
        <mat-error>
          {{'PARKING_PRICING.FORM.NAME_IS_REQUIRED' | transloco}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="mb-2 w-100">
      <input matInput [placeholder]="'PARKING_PRICING.DESCRIPTION' | transloco" formControlName="description" required>
      <!-- <mat-error *ngIf="!parkingPricingForm.controls.description.valid && parkingPricingForm.controls.description.touched">
      {{'PARKING_PRICING.FORM.DESCRIPTION_IS_REQUIRED' | transloco}}
    </mat-error> -->
  </mat-form-field>

  <mat-form-field class="mb-2" appearance="outline">
    <mat-label>{{ 'PARKING_PRICING.CODE' | transloco }}</mat-label>
    <input matInput type="text" formControlName="code" />
    @if (!parkingPricingForm.controls.code.valid && parkingPricingForm.controls.code.touched) {
      <mat-error class="mb-2"
        >
        {{'PARKING_PRICING.FORM.CODE_IS_REQUIRED' | transloco}}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="mb-2" appearance="outline">
    <mat-label>{{ 'PARKING_PRICING.PRICE' | transloco }}</mat-label>
    <input matInput
      [value]="this.parkingPricingForm.controls.totalPrice.value/(1 + this.parkingPricingForm.controls.vat.value)"
      min="1" type="number" formControlName="price" />
    @if (!parkingPricingForm.controls.price.valid && parkingPricingForm.controls.price.touched) {
      <mat-error class="mb-2"
        >
        {{'PARKING_PRICING.FORM.PRICE_IS_REQUIRED' | transloco}}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="mb-2" appearance="outline">
    <mat-label>{{ 'PARKING_PRICING.VAT' | transloco }}</mat-label>
    <input matInput type="number" formControlName="vat" />
  </mat-form-field>

  <mat-form-field class="mb-2" appearance="outline">
    <mat-label>{{ 'PARKING_PRICING.TOTAL_PRICE' | transloco }}</mat-label>
    <!-- [value]="this.parkingPricingForm.controls.price.value + this.parkingPricingForm.controls.price.value*this.parkingPricingForm.controls.vat.value"  -->
    <input matInput type="number" formControlName="totalPrice" />
  </mat-form-field>

  <mat-form-field class="mb-2" appearance="outline">
    <mat-label>{{ 'PARKING_PRICING.ACTIVE' | transloco }}</mat-label>
    <mat-select formControlName="active">
      @for (option of activeOptions; track option) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <!-- parkingPricingForm.dirty -->
  <button mat-raised-button color="primary" [disabled]="parkingPricingForm.invalid || isLoading" (click)="submitForm()">
    @if (!data.edit) {
      <span>
        {{ 'PRICING.FORM.CREATE' | transloco }}
      </span>
    }
    @if (data.edit) {
      <span>
        {{'PRICING.FORM.EDIT' | transloco }}
      </span>
    }
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>
